module.exports = __webpack_public_path__ + "static/media/bg-characterdb7ddbd99d8fae60f188495b279f181f.webp";